export enum TranscriptionState {
  FAILED = 'FAILED',
  INITIALIZED = 'INITIALIZED',
  STARTED = 'STARTED',
  STOPPED = 'STOPPED',
}
